<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/hrHuaV/tc-custom/9781466822733.jpg?1728726057067" alt="This image is the cover for the book Bill, the Galactic Hero"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Bill, the Galactic Hero
      </h1>
      <p class="bookDescription body article font2">
        <b>“The funniest science fiction book ever written” is a space military parody about a hapless soldier from a Science Fiction Hall of Fame inductee (Terry Pratchett, <i>New York Times</i>–bestselling author of the Discworld novels).</b><br/><br/>It was the highest honour to defend the Empire against the dreaded Chingers, an enemy race of seven-foot-tall lizards. But Bill, a Technical Fertilizer Operator from a planet of farmers, wasn’t interested in honour—he was only interested in two things: his chosen career, and the shapely curves of Inga-Maria Calyphigia.<br/><br/>Then a recruiting robot shanghaied him with knockout drops, and he came to in deep space, aboard the Empire warship Christine Keeler. And from there, things got even worse . . .<br/><br/><b>Praise for Harry Harrison</b><br/><br/>“A perfectly grand storyteller.” —David Brin, Hugo and Nebula Award–winning author of <i>Star Tide Rising</i><br/><br/>“Few commercial writers are more deserving of their popularity than Harrison, a fine writer who occasionally reaches brilliant heights.” —<i>Publishers Weekly</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Harry Harrison
      </h2>
      
      <p class="authorDescription body article">Harry Harrison (1925&ndash;2012) began writing science fiction in the 1950s and remains one of the top-selling authors in the genre. Harrison is best known for his Stainless Steel Rat, Deathworld, and West of End series, as well as&#160;<I>Make Room! Make Room!</I>, which was turned into the movie&#160;<I>Soylent Green&#160;</I>starring Charlton Heston and Edward G. Robinson. His novels have appeared on the&#160;<I>New York Times</I>&#160;bestseller list, and in 2009 he was awarded the Damon Knight SF Grand Master Award by the Science Fiction Writers of America.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?06464234